<template>
  <EmdPanel>
    <EmdPanelSection :title="$t('recipients.create.bank_account')">
      <EmdFormGroup
        :label="$t('recipients.create.bank')"
        required
        :state="getState(vuelidate.default_bank_account.bank)"
        :feedbacks="feedbacks(vuelidate.default_bank_account.bank)"
      >
        <EmdInput
          @input="vuelidate.default_bank_account.bank.$touch"
          :placeholder="$t('recipients.create.bank_placeholder')"
          v-model="default_bank_account.bank"
          list="banks"
          name="bank"
        />
        <datalist id="banks">
          <option
            v-bind:key="bank.value"
            v-for="bank in banks"
            :value="bank.value"
          >
            {{ bank.text }}
          </option>
        </datalist>
      </EmdFormGroup>

      <div class="eu-flex eu-align-content_stretch">
        <div class="eu-flex-item eu-basis_7">
          <EmdFormGroup
            :label="$t('recipients.create.branch_number')"
            required
            :state="getState(vuelidate.default_bank_account.branch_number)"
            :feedbacks="feedbacks(vuelidate.default_bank_account.branch_number)"
          >
            <EmdInput
              @input="vuelidate.default_bank_account.branch_number.$touch"
              v-model="default_bank_account.branch_number"
              name="branch_number"
            />
          </EmdFormGroup>
        </div>

        <div class="eu-flex-item eu-basis_5">
          <EmdFormGroup
            :label="$t('recipients.create.branch_check_digit')"
            :state="getState(vuelidate.default_bank_account.branch_check_digit)"
            :feedbacks="
              feedbacks(vuelidate.default_bank_account.branch_check_digit)
            "
          >
            <EmdInput
              @input="vuelidate.default_bank_account.branch_check_digit.$touch"
              v-model="default_bank_account.branch_check_digit"
              name="branch_check_digit"
            />
          </EmdFormGroup>
        </div>
      </div>

      <div class="eu-flex eu-align-content_stretch">
        <div class="eu-flex-item eu-basis_7">
          <EmdFormGroup
            :label="$t('recipients.create.account_number')"
            required
            :state="getState(vuelidate.default_bank_account.account_number)"
            :feedbacks="
              feedbacks(vuelidate.default_bank_account.account_number)
            "
          >
            <EmdInput
              @input="vuelidate.default_bank_account.account_number.$touch"
              v-model="default_bank_account.account_number"
              name="account_number"
            />
          </EmdFormGroup>
        </div>

        <div class="eu-flex-item eu-basis_5">
          <EmdFormGroup
            :label="$t('recipients.create.branch_check_digit')"
            required
            :state="
              getState(vuelidate.default_bank_account.account_check_digit)
            "
            :feedbacks="
              feedbacks(vuelidate.default_bank_account.account_check_digit)
            "
          >
            <EmdInput
              type="text"
              @input="vuelidate.default_bank_account.account_check_digit.$touch"
              v-model="default_bank_account.account_check_digit"
              name="account_check_digit"
            />
          </EmdFormGroup>
        </div>
      </div>

      <EmdFormGroup
        :label="$t('recipients.create.account_type')"
        required
      >
        <div class="eu-mt_2">
          <EmdRadio
            :label="$t('recipients.create.type_checking')"
            id="type_checking"
            name="account_type"
            value="checking"
            v-model="default_bank_account.type"
            class="eu-mr_4 eu-mb_2"
          />

          <EmdRadio
            :label="$t('recipients.create.type_conjunct_checking')"
            value="conjunct_checking"
            id="type_conjunct_checking"
            name="account_type"
            v-model="default_bank_account.type"
            class="eu-mr_4 eu-mb_2"
          />

          <EmdRadio
            :label="$t('recipients.create.type_savings')"
            value="savings"
            id="type_savings"
            name="account_type"
            v-model="default_bank_account.type"
            class="eu-mr_4 eu-mb_2"
          />

          <EmdRadio
            :label="$t('recipients.create.type_conjunct_savings')"
            value="conjunct_savings"
            id="type_conjunct_savings"
            name="account_type"
            v-model="default_bank_account.type"
            class="eu-mr_4 eu-mb_2"
          />
        </div>
      </EmdFormGroup>

      <EmdFormGroup
        :label="$t('recipients.create.account_name')"
        required
        :state="getState(vuelidate.default_bank_account.holder_name)"
        :feedbacks="feedbacks(vuelidate.default_bank_account.holder_name)"
      >
        <EmdInput
          @input="vuelidate.default_bank_account.holder_name.$touch"
          v-model="default_bank_account.holder_name"
          name="holder_name"
        />
      </EmdFormGroup>
      <EmdFormGroup
        :label="$t('recipients.create.type')"
        required
      >
        <EmdRadio
          :label="$t('holder_type_individual')"
          id="holder_type_individual"
          name="holder_type"
          value="individual"
          v-model="default_bank_account.holder_type"
          class="eu-mr_4 eu-mb_2"
        />

        <EmdRadio
          :label="$t('holder_type_company')"
          id="holder_type_company"
          name="holder_type"
          value="company"
          v-model="default_bank_account.holder_type"
          class="eu-mb_2"
        />
      </EmdFormGroup>
      <EmdFormGroup
        :label="$t('holder_document')"
        required
        :state="getState(vuelidate.default_bank_account.holder_document)"
        :feedbacks="feedbacks(vuelidate.default_bank_account.holder_document)"
      >
        <EmdInput
          @input="vuelidate.default_bank_account.holder_document.$touch"
          v-model="default_bank_account.holder_document"
          :mask="documentMask"
          name="holder_document"
        />
      </EmdFormGroup>
    </EmdPanelSection>
  </EmdPanel>
</template>

<script>
import {
  EmdPanel,
  EmdPanelSection,
  EmdFormGroup,
  EmdInput,
  EmdRadio
} from 'emerald-vue/src/components'
import { getState, feedbacks } from '@/utils/form.utils'
import banks from '@/utils/banks.utils'

export default {
  name: 'Identification',
  components: {
    EmdPanel,
    EmdPanelSection,
    EmdFormGroup,
    EmdInput,
    EmdRadio
  },
  data: function () {
    return {
      banks: Object.keys(banks).map(code => ({
        value: code,
        text: banks[code]
      })),
      getState,
      feedbacks
    }
  },
  computed: {
    documentMask () {
      return this.default_bank_account.holder_type === 'individual'
        ? '###.###.###-##'
        : 'XX.XXX.XXX/XXXX-##'
    }
  },
  props: {
    default_bank_account: {
      type: Object,
      required: true
    },
    vuelidate: {
      type: Object,
      required: true
    }
  }
}
</script>

<style>
.ui.selection.active.dropdown,
.ui.selection.active.dropdown .menu {
  border-color: #d5dbe1 !important;
}
</style>
<i18n>
  {
    "pt-BR": {
      "holder_document": "Documento da conta bancária",
      "holder_type_individual": "Pessoa física",
      "holder_type_company": "Pessoa jurídica"
    },
    "en-US": {
      "holder_document": "Bank account document",
      "holder_type_individual": "Individual",
      "holder_type_company": "Company"
    }
  }
</i18n>
